import { gql } from "graphql-tag";

export const getEmergencyContact = gql`
  query getEmergencyContact {
    getEmergencyContact {
      results {
        id
        userId
        contactName
        phoneNumber
      }
      status
      errorMessage
    }
  }`;

export const addEmergencyContact = gql`
  mutation addEmergencyContact($data: String) {
    addEmergencyContact(data: $data) {
      results {
        id
        contactName
        phoneNumber
      }
      status
      errorMessage
    }
  }`;

export const deleteEmergencyContact = gql`
  mutation deleteEmergencyContact($contactId: Int!) {
    deleteEmergencyContact(contactId: $contactId) {
      status
      errorMessage
    }
  }`;

// Share the client's live job location with their emergency contacts (parity with the app SOS).
export const shareLiveLocations = gql`
  mutation shareLiveLocations($bookingId: Int!, $currentLocation: String) {
    shareLiveLocations(bookingId: $bookingId, currentLocation: $currentLocation) {
      status
      errorMessage
    }
  }`;
